<template>
    <div class="ct-component-loading" v-if="loading">
        <div class="spinner-border text-light text-danger" role="status">
          <span class="sr-only">Loading...</span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        loading:
        {
            type: Boolean,
            default: true
        }
    }
}
</script>

<style scoped lang="scss">
@import "@styles/_theme.scss";
.ct-component-loading{
    position: absolute  !important;
    top:0px !important;
    bottom: 0px !important;
    left:0px !important;
    right:0px !important;
    background-color: rgba(0,0,0,.3) !important;
    z-index: $zindex-modal-backdrop !important;

    .spinner-border{
        width:32px;
        height:32px;
        position: absolute;
        top:50%;
        left:50%;
        margin-top: -16px;
        margin-left: -16px;
    }
}
</style>